import _ from "lodash";

import intl from "react-intl-universal";

import httpService from "../_utils/http-service";
import * as types from "./types";
import {
  getAuthHttpConfig,
  getRestaurantHttpConfig
} from "../_utils/auth-utils";

import { traceEvent } from "../_utils/analytics-utils";

export const addCard = ({ customerId, affipayData }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .post(
        `customers/${customerId}/payments/methods`,
        {
          paymentProvider: 'AFFIPAY',
          affipayData: affipayData
        },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          httpService
            .get(`customers/${customerId}/payments/methods`, getAuthHttpConfig(storage))
            .then(response => {
              if (response.data.statusCode === 200) {
                let cards = response.data.data.affipayPaymentMethods;
                dispatch({ type: types.SET_CARDS, payload: cards });
                callback({ success: true, paymentMethodId:  res.data.data.paymentMethodId});
              } else {
                traceEvent("error", "addCard");
                callback({ success: false });
              }
            });

        } else {
          traceEvent("error", "addCard");
          callback({ success: false, message: res.data.message });
        }
      })
      .catch(err => {
        traceEvent("error", "addCard");
        callback({ success: false, message: intl.get("general.serverError") });
      });
  };
};

export const setDefaultCard = ({ cards, customerId, paymentMethodId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .put(
        // `/v2/customers/${customerId}/card/${cardId}/default`,
        `/customers/${customerId}/payments/methods/${paymentMethodId}/favorite`,
        null,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          _.map(cards, card => (card.isFavorite = false));
          var defaultCard = _.find(cards, { paymentMethodId: paymentMethodId });
          defaultCard.isFavorite = true;
          dispatch({ type: types.SET_CARDS, payload: {...cards} });
          callback({ success: true });
        } else {
          traceEvent("error", "setDefaultCard");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "setDefaultCard");
        callback({ success: false });
      });
  };
};

export const removeCard = ({ cards, customerId, paymentMethodId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    httpService
      .delete(
        // `/v2/customers/${customerId}/card/${cardId}/delete`,
        `/customers/${customerId}/payments/methods/${paymentMethodId}`,
        null,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          cards = _.filter(cards, item => item.paymentMethodId !== paymentMethodId);
          dispatch({ type: types.SET_CARDS, payload: cards });
          callback({ success: true });
        } else {
          traceEvent("error", "removeCard");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "removeCard");
        callback({ success: false });
      });
  };
};

export const sendOrder = (
  paymentInfo,
  callback
) => {
  return async function(dispatch, getState) {
    const storage = getState().storage;
    const customerId = paymentInfo.customerId;
    const orderId = paymentInfo.orderId;
    // const paymentMethod = paymentInfo.paymentMethod;
    delete paymentInfo.customerId;
    delete paymentInfo.orderId;
    // delete paymentInfo.paymentMethod;
    traceEvent("order", "send");
    // dispatch({
    //   type: types.SET_PAYING,
    //   payload: paymentMethod
    // });

    const payload = {
      ...paymentInfo
    };

    if (storage.customerName !== undefined) {
      payload.customerName = storage.customerName;
    }

    httpService
      .put(
        `v2/customers/${customerId}/order/${orderId}/gng/send`,
        payload,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        dispatch({ type: types.SET_PAYING, payload: "" });

        if (res.data.success === true) {
          const order = res.data.data;
          callback({ success: true, order });
        } else {
          if (res.data.statusCode === 103 || res.data.statusCode === 104) {
            callback({
              success: false,
              groupOrderFailed: true,
              message: res.data.message
            });
            traceEvent("error", "sendOrder");
          } else {
            traceEvent("error", "sendOrder");
            callback({ success: false, message: res.data.message });
          }
        }
      })
      .catch(err => {
        traceEvent("error", "sendOrder");
        callback({ success: false, message: err });
      });
  };
};

export const acceptOrder = (
  { customerId, orderId, restaurantId, pickupTime },
  callback
) => {
  return function(dispatch, getState) {
    let httpConfig = getRestaurantHttpConfig();
    httpService
      .put(
        `restaurants/${restaurantId}/orders/${orderId}/accept`,
        {
          pickupTime
        },
        httpConfig
      )
      .then(async response => {
    
        if (response.data.statusCode === 200) {
          const storage = getState().storage;
          let res = await httpService.get(
            `/customers/${customerId}/order/${orderId}`,
            getAuthHttpConfig(storage)
          );

          if (res.data.statusCode === 200) {
            callback({ success: true, order: res.data.data });
          } else {
            callback({ success: false });
          }
        } else {
          callback({ success: false });
        }
      })
      .catch(err => {
     
        callback({ success: false });
      });
  };
};

export const rejectOrder = (
  { customerId, orderId, restaurantId },
  callback
) => {
  return function(dispatch, getState) {
    httpService
      .put(
        `restaurants/${restaurantId}/orders/${orderId}/reject`,
        null,
        getRestaurantHttpConfig()
      )
      .then(async response => {
        const storage = getState().storage;
        if (response.data.statusCode === 200) {
          let res = await httpService.get(
            `/customers/${customerId}/order/${orderId}`,
            getAuthHttpConfig(storage)
          );

          if (res.data.statusCode === 200) {
            callback({ success: true, order: res.data.data });
          } else {
            callback({ success: false });
          }
        } else {
          callback({ success: false });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};
